module.exports = __webpack_public_path__ + "static/media/bertonimed-logo.743e1634.svg";